import FormFieldCheckBox from '@acorn-portal/shared/src/components/inputs/FormFieldCheckbox';
import FormTextField from '@acorn-portal/shared/src/components/inputs/FormTextField';
import HelperModal from '@acorn-portal/shared/src/components/modal/HelperModal';
import { AlignedText } from '@acorn-portal/shared/src/components/renewal/direct-debit-details';
import { Box, Button, Typography } from '@mui/material';
import { FormikProps } from 'formik';

import { FieldSet } from '@acorn-portal/shared/src/components/fieldSet';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import extractBeforeDash from '@acorn-portal/shared/src/utils/extractBeforeDash';
import { getFinanceWording } from '@acorn-portal/shared/src/utils/get-finance-wording';
import { isYoungDriver } from '@acorn-portal/shared/src/utils/is-young-driver';
import { TERMS_MODAL } from '@acorn-portal/shared/src/utils/modalText';
import { FC, useState } from 'react';
import { ManagedPaymentsValues } from '../types';
interface IBankDetails {
	formik: FormikProps<ManagedPaymentsValues>;
}

const BankDetailsForm: FC<IBankDetails> = ({ formik }) => {
	const [open, toggleModal] = useState(false);
	const company = extractBeforeDash(import.meta.env.VITE_JOURNEY || '');
	let instalmentWording = '';
	const fullPolicy = useAppSelector((state) => state.fullPolicy);
	const isNonFinance = fullPolicy.nonFinancePolicy;
	const isYDDriver = isYoungDriver(fullPolicy.scheme);
	if (!isNonFinance && !isYDDriver) instalmentWording = getFinanceWording(company);

	return (
		<FieldSet title='Bank Details'>
			<FormTextField
				name='account_number'
				label='Account Number'
				value={formik.values.account_number}
				onChange={formik.handleChange}
				onBlur={formik.handleBlur}
				error={formik.touched.account_number && Boolean(formik.errors.account_number)}
				helperText={formik.touched.account_number && formik.errors.account_number}
				format='accountNumber'
			/>
			<FormTextField
				id='sort_code'
				name='sort_code'
				label='Sort Code'
				value={formik.values.sort_code}
				onChange={formik.handleChange}
				onBlur={formik.handleBlur}
				error={formik.touched.sort_code && Boolean(formik.errors.sort_code)}
				helperText={formik.touched.sort_code && formik.errors.sort_code}
				format='sortCode'
			/>

			{instalmentWording && <AlignedText sx={{ marginBottom: 5 }}>{instalmentWording}</AlignedText>}

			<Box sx={{ mt: 2 }}>
				<FormFieldCheckBox
					label=''
					onChange={() => {
						formik.setFieldValue('accept_dd_terms', !formik.values.accept_dd_terms);
					}}
					onBlur={() => formik.setFieldTouched('accept_dd_Terms')}
					options={[
						{
							label: (
								<Typography
									color={formik.touched.accept_dd_terms && Boolean(formik.errors.accept_dd_terms) ? 'error' : undefined}
								>
									Please confirm the above details are correct, and that you agree with the{' '}
									<Button
										variant='contrast'
										sx={{
											pl: 0,
											'&:hover': {
												background: 'transparent',
												color: 'text.secondary',
											},
										}}
										onClick={() => toggleModal(true)}
									>
										Terms and Conditions
									</Button>
								</Typography>
							),
							value: formik.values.accept_dd_terms,
						},
					]}
					error={formik.touched.accept_dd_terms && Boolean(formik.errors.accept_dd_terms)}
					helperText={formik.touched.accept_dd_terms && formik.errors.accept_dd_terms}
				/>
				{TERMS_MODAL && <HelperModal onClose={() => toggleModal(false)} open={open} {...TERMS_MODAL} />}
			</Box>
		</FieldSet>
	);
};

export default BankDetailsForm;
